import React from "react";
import Modal from "react-bootstrap/Modal";

const ConfirmBox = ({ show, handleClose, message, title, handleSubmit, deleteBtn = true }) => {
  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header className="popupheader delete pt-4">{title}</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group pt-4 pb-5 m-0">
                <p className="popupheading delete p-0 m-0">{message}</p>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mt-2 mb-2 footerbtn">
                  <button onClick={handleClose}>Cancel</button>
                  {deleteBtn ? (
                    <button className="ms-3" onClick={handleSubmit}>
                      Delete
                    </button>
                  ) : (
                    <button className="ms-3" onClick={handleSubmit}>
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmBox;
